"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTransporterToLogisticOrderQuery = applyTransporterToLogisticOrderQuery;
const logistic_common_1 = require("@invivodf/logistic-common");
function applyTransporterToLogisticOrderQuery(applyTransporterQuery) {
    const validTransporter = (0, logistic_common_1.findTransporter)(getAllTransporters(applyTransporterQuery), {
        longestDimension: (0, logistic_common_1.findLongestDimension)(applyTransporterQuery.lines),
        unWrappedDimensions: (0, logistic_common_1.computeUnwrappedDimensions)(applyTransporterQuery.lines),
        totalWeight: (0, logistic_common_1.computeTotalWeight)(applyTransporterQuery.lines)
    });
    return !validTransporter
        ? applyTransporterQuery
        : buildLogisticOrderWithTransporter(applyTransporterQuery, validTransporter);
}
function buildLogisticOrderWithTransporter(applyTransporterQuery, validTransporter) {
    var _a, _b;
    return {
        ...applyTransporterQuery,
        shippingDelay: validTransporter.delay
            ? { unit: (_a = validTransporter.delay) === null || _a === void 0 ? void 0 : _a.unit, value: (_b = validTransporter.delay) === null || _b === void 0 ? void 0 : _b.min }
            : applyTransporterQuery.shippingDelay,
        transporter: validTransporter
    };
}
function getAllTransporters(query) {
    return query.lines[0].selectedLogisticOffer.transporters || [];
}
